<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="5">
              <b-form-group>
                <label for="code">{{$t('page.generic.code')}} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="company.code" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group>
                <label for="label">{{$t('page.generic.name')}} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="company.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label for="active">{{$tc('page.generic.state', 1)}}</label><br/>
                <c-switch id="active" class="mx-1" v-model="company.active" color="success" variant="pill" label/>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{$t('page.generic.description')}}</label>
                <b-form-textarea aria-describedby="descriptionField" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="company.description"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <company-models :tableData="companyModels" @deleteCompanyModel="deleteCompanyModel"></company-models>
        <b-card>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createCompany">
                {{$t('actions.save')}}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'companyRoute'}">
                {{$t('actions.abort')}}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <model-list @addModels="addModels"></model-list>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import ModelList from "../company/ModelList";
  import CompanyModels from "../company/CompanyModels";
  import {Switch as cSwitch} from '@coreui/vue'
  import RequiredField from "../../components/RequiredField";

  export default {
    name: 'modelEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      ModelList,
      CompanyModels,
      PageTitle,
      cSwitch
    },
    data() {
      return {
        company: {},
        errors: [],
        companyModels: [],
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    },
    methods: {
      createCompany() {
        this.company.companyModels = this.companyModels.map((value) => {
          return { model: value.model.id, mandatory: value.mandatory };
        });
        this.$http.post(`api/companies/`, this.company)
          .then(response => response.json())
          .then((data) => {
            this.$router.push({path: `/company/show/${data.id}`});
          })
          .catch((error) => {
            this.errors = error.body.errors;
            error.body.errors.forEach(function (element) {
              miniToastr.error(element.message);
            });
          })
      },
      addModels(selectedModels) {
        let vm = this;
        selectedModels.forEach(function(element) {
          if(vm.companyModels.findIndex(item => item.model.code === element.code) === -1) {
            let cm = {
              id: -1,
              model: {
                id: element.id,
                code: element.code,
                categories: element.categories,
                description: element.description,
                modelVersion: element.modelVersion,
                modelFormat: element.modelFormat
              },
              mandatory: false,
              added: true
            };
            vm.companyModels.push(cm)
          }
        });
      },
      deleteCompanyModel(selectedCompanyModel){
        this.companyModels.splice(this.companyModels.findIndex(item => item.model.code === selectedCompanyModel.model.code), 1);
      }
    },
    computed: {
      saveEnabled: function() {
        return (this.company.code && this.company.label);
      }
    }
  }
</script>
